import { PERMISSIONS } from "@/constants";

export default [
    {
        name: "chatbot",
        meta: {
            title: "Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot",
        component: () => import("@/views/pages/chatbot/index.vue"),
    },
    {
        name: "chatbot-candidate",
        meta: {
            title: "Candidate - Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot/candidate/:candidateId/sessions",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-candidate-kyb",
        meta: {
            title: "KYB Documents - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/kyb",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-candidate-vat",
        meta: {
            title: "VAT Statement - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/vat",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-candidate-bank-statement",
        meta: {
            title: "Bank Statement - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/bank-statement",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-candidate-overview",
        meta: {
            title: "Candidate Overview - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-candidate-identity",
        meta: {
            title: "Candidate Identity - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/identity",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-candidate-financial",
        meta: {
            title: "Financial Documents - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/financial",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-candidate-supporting",
        meta: {
            title: "Supporting Documents - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/supporting",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-candidate-notes",
        meta: {
            title: "Notes & Activity - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/notes",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-candidate-files",
        meta: {
            title: "Select Files - Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot/candidate/:candidateId/files",
        component: () => import("@/views/pages/chatbot/candidateFiles.vue"),
        props: true
    },
    {
        name: "chatbot-upload",
        meta: {
            title: "Upload File - Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot/candidate/:candidateId/upload",
        component: () => import("@/views/pages/chatbot/upload.vue"),
        props: true
    },
    {
        name: "chatbot-chat-session",
        meta: {
            title: "Chat Session - Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot/candidate/:candidateId/session/:sessionId",
        component: () => import("@/views/pages/chatbot/chatSession.vue"),
        props: true
    },
    {
        name: "chatbot-file-details",
        meta: {
            title: "File Details - Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot/candidate/:candidateId/file/:fileId",
        component: () => import("@/views/pages/chatbot/fileDetails.vue"),
        props: true
    },
    {
        name: "chatbot-report-details",
        meta: {
            title: "Report Details - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/file/:fileId/report",
        component: () => import("@/views/pages/chatbot/reportDetails.vue"),
        props: true
    },
    {
        name: "chatbot-payer-report-details",
        meta: {
            title: "Payer Report Details - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/payer-report",
        component: () => import("@/views/pages/chatbot/payerReportDetails.vue"),
        props: true
    },
    {
        name: "chatbot-automated-assessment-input",
        meta: {
            title: "Automated Assessment Model - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/automated-assessment-input",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-automated-assessment-report",
        meta: {
            title: "Automated Assessment Report - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/automated-assessment-report",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-automated-assessment-dashboard",
        meta: {
            title: "Automated Assessment Dashboard - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/automated-assessment-dashboard",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-candidate-analysis-pack",
        meta: {
            title: "Company Analysis Pack - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/analysis-pack",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-candidate-forecasting",
        meta: {
            title: "Forecasting Parameters - Financial Analyser"
        },
        path: "/manage/chatbot/candidate/:candidateId/forecasting",
        component: () => import("@/views/pages/chatbot/candidate.vue"),
        props: true
    },
    {
        name: "chatbot-config",
        meta: {
            title: "Configuration - Financial Analyser",
            requiresAuth: true,
            permission_scopes: [PERMISSIONS.CHATBOT_ALL],
        },
        path: "/manage/chatbot/config",
        component: () => import("@/views/pages/chatbot/config.vue"),
    }
]